<template>
  <div class="content">
    <div class="table-page-operator-wrapper action-btn" >
      <a-button :disabled="isRuningPlan" @click="handleRunPlan" type="primary">执行调整</a-button>
      <a-button @click="handleExport" :disabled="!$refs.dataTable || !$refs.dataTable.myDataSource || $refs.dataTable.myDataSource.length === 0" type="primary">导出</a-button>
      <!-- <a-button @click="handleExport" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']"
      >导出</a-button -->
    </div>
    <a-spin :spinning="isLoading">
      <ls-api-table
        class="table"
        ref="dataTable"
        :columns="columnsNative"
        :tableProps="tableProps"
        rowKey="keyId"
        :scroll="{ fixScreen: true, x: 1300 }"
        :pagination="false"
      >
        <!-- 操作 -->
        <span slot="operation" slot-scope="{ record, $index }">
          <a v-if="!isEdit || currentId !== record.keyId" @click="handleEdit(record, $index)">编辑</a>
          <a v-if="!isEdit || currentId !== record.keyId" class="ml10" @click="handleDelete(typeList, record)">删除</a>
          <a v-if="isEdit && currentId === record.keyId" @click="handleSave(record)">保存</a>
          <a v-if="isEdit && currentId === record.keyId" @click="handleCancel(record)" class="ml10">取消</a>
        </span>
        <template slot="month" slot-scope="{ record }">
          <span>{{ record.monthStart + '~' + record.monthEnd }}</span>
        </template>
        <template slot="updateTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="createTime" slot-scope="{ text }">
          <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
        </template>
        <template slot="versionCode" slot-scope="{ record }">
          <a @click="handleGoVersion(record)" class="ml10">{{ record.versionCode }}</a>
        </template>
        <!-- 月份 -->
        <template slot="adjustQuantity" slot-scope="{ record }">
          <!-- <span v-if="!isEdit || currentId !== record.keyId">{{ record[column.dataIndex].initialDeliveryRatio+ '%' }}</span>
          <a-input-number
            v-if="isEdit && currentId === record.keyId"
            v-model="record[column.dataIndex].initialDeliveryRatio"
            size="small"
          /> -->
          <a-input-number
            v-if="!isRuningPlan && record.adjustQuantity !== undefined"
            @change="(val)=>handleNumber(val,record)"
            :max="record.quantity"
            v-model="record.adjustQuantity"
            size="small"
          />
          <span v-else>{{ record.adjustQuantity }}</span>
        </template>
      </ls-api-table>
    </a-spin>

  </div>
</template>

  <script>
import {
  apiScpSopFcInitialDeliveryRatio,
  apiDelScpSopFcInitialDeliveryRatio
} from '@/api/scp/shipmentForecast/shipmentForecastSetting'
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import { apiInPlanSheetList, apiInPlanSheetExecute } from '@/api/mps/basic-data/mps-plan-adjustment.js'

export default {
  components: {
    },
  props: {
    id: {
      type: String,
      default: '1' // 设置默认值为'Hello from child'
    }
  },
  data () {
    return {
      isRuningPlan: false,
      isLoading: false,
      url: '/scp/scpSopFcInitialDeliveryRatio/import',
      isEdit: false,
      tableList: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiInPlanSheetList, true),
        pageCurrent: true
      },
      columns: [],
      columnsServe: [],
      // 表格字段

      columnsNative: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 160,
          ellipsis: true,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '工艺大类',
          dataIndex: 'category',
          width: 120,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '物料名称',
          ellipsis: true,
          dataIndex: 'itemName',
          width: 120,
          fixed: 'left',
          align: 'center'
        },

        {
          title: '规格描述',
          dataIndex: 'specification',
          ellipsis: true,
          fixed: 'left',
          width: 180,
          align: 'left'
        },
        {
          title: '产品工艺得分',
          dataIndex: 'routingSource',
          fixed: 'left',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '调入供应商',
          dataIndex: 'supplierName',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '单据编号',
          dataIndex: 'orderNumber',
          width: 180,
          align: 'center'
        },
        {
          title: '完成日期',
          dataIndex: 'newDuckDate',
          scopedSlots: { customRender: 'updateTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          width: 180,
          align: 'center'
        },
        {
          title: '平均采购价',
          dataIndex: 'averagePurchasePrice',
          width: 180,
          align: 'center'
        },
        {
          title: '建议调整数量',
          dataIndex: 'adviseQuantity',
          width: 180,
          align: 'center'
        },
        {
          title: '调整数量',
          dataIndex: 'adjustQuantity',
          scopedSlots: { customRender: 'adjustQuantity' },
          width: 180,
          align: 'center'
        },
        {
          title: '建议调整金额',
          dataIndex: 'total',
          width: 180,
          align: 'center'
        }
        // ,
        // {
        //   title: '操作',
        //   fixed: 'right',
        //   dataIndex: 'operation',
        //   scopedSlots: { customRender: 'operation' },
        //   width: 120,
        //   align: 'center'
        // }
      ],
      queryParams: {
      }
    }
  },
  methods: {
    handleNumber (val, record) {
      if (val > record.quantity) {
        this.$message.error('调整数量不能大于数量')
      }
    },
    handleRunPlan () {
      this.isRuningPlan = true
      const tempPlanSheet = cloneDeep(this.$refs.dataTable.myDataSource.filter(item => !item.isTotal))
      tempPlanSheet.forEach(item => {
        item.total = item.total.toString().replace(',', '')
      })
      apiInPlanSheetExecute({ version: this.queryParams.version, planSheet: tempPlanSheet }).then((response) => {
        if (response.code === 200) {
          this.$emit('handle-run-plan-finish')
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => {
        this.isRuningPlan = false
        })
    },
    filterData (list) {
    const filterList = this.tableList.filter(item => {
      // 物料
      if (this.queryParams.itemId && this.queryParams.itemId.length > 0) {
        if (this.queryParams.itemId.includes(item.itemCode)) { return true } else {
          return false
        }
      }
      // 调出供应商
      if (this.queryParams.supplierAbbreviationIn) {
        if (this.queryParams.supplierAbbreviationIn === item.supplierName) { return true } else {
          return false
        }
      }
       // 调整期间
      if (this.queryParams.demandDeliveryDate && this.queryParams.demandDeliveryDate.length > 0) {
        if (this.queryParams.demandDeliveryDate.includes(item.period)) { return true } else {
          return false
        }
      }
        return true
      }
    )
    return filterList
    },
   // 新增/修改框事件
     handleOk () {
        // this.onSearch()
      },
    handleDelete (tableList, record) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除该项的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          const ids = []
          self.columnsServe.forEach((column) => {
            console.log(column.indexKey)
            const id = record[column.indexKey].id
            ids.push(id)
          })
          apiDelScpSopFcInitialDeliveryRatio(ids).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑-保存
    handleSave (record) {
     // <!-- 行汇总必须为100% -->
     let count = 0
      for (const key in record) {
          if (key.includes('month')) {
            count = count + (record[key].initialDeliveryRatio ? record[key].initialDeliveryRatio : 0)
        }
      }
      if (!(count >= 95 && count <= 100)) {
        this.$message.error('行汇总必须为95%到100%之间')
        return
      }

      const recordCopy = JSON.parse(JSON.stringify(record))
      apiScpSopFcInitialDeliveryRatio(recordCopy).then((response) => {
        if (response.code === 200) {
          this.$message.success('更新成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 表单搜索
    onSearch (params) {
      if (params) {
        this.queryParams = params
      }
      this.isEdit = false
      //  this.$refs.dataTable.searchParams = this.queryParams;
      //  this.$refs.dataTable.getData();
      this.getTableInfo()
    },
    getTableInfo () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      apiInPlanSheetList(this.queryParams).then((response) => {
        this.isLoading = false
        if (response.code === 200) {
          this.tableList = response.data
          let totalQuantity = 0
          let totalAdviseQuantity = 0
          let totalAdviseMoney = 0
          this.tableList.forEach((obj, index) => {
            obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
            totalQuantity += obj.quantity
            totalAdviseQuantity += obj.adviseQuantity
            const tempTotal = parseFloat(obj.total)
            obj.total = tempTotal
            totalAdviseMoney += tempTotal * 1000
          })
          this.tableList.push({
            category: '汇总',
            isTotal: true,
            quantity: totalQuantity,
            adviseQuantity: totalAdviseQuantity,
            total: parseFloat((totalAdviseMoney / 1000).toFixed(3))
          })
          this.$refs.dataTable.myDataSource = this.filterData(this.tableList)
          // this.onSearch()
        } else {
          this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
          this.$message.error(response.msg)
        }
      }).catch((error) => {
        this.tableList = []
        this.$refs.dataTable.myDataSource = this.tableList
        this.isLoading = false
        // 处理 API 调用失败的情况
        console.error('API 调用失败: ', error);
      })
    },
    // 编辑
    handleEdit (record, index) {
      if (this.currentId && record.keyId !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.keyId
    },
    handleExport () {
      const tempPlanSheet = cloneDeep(this.$refs.dataTable.myDataSource.filter(item => !item.isTotal))
      tempPlanSheet.forEach(item => {
        item.total = item.total.toString().replace(',', '')
      })
      this.downloadByJson('scp/scpMpsPlans/exportInPlanSheet', tempPlanSheet, '调入明细导出.xlsx')
    },
    formatNumber(num) {
      // 先确保输入的是字符串，防止数字类型自动转换为科学计数法
      num = num.toString();
      var parts = num.split('.');
      // 分离整数部分和小数部分
      var integerPart = parts[0];
      var decimalPart = parts.length > 1 ? '.' + parts[1] : '';

      // 对整数部分进行千分位处理
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return integerPart + decimalPart;
    }
  },
  created () {
    //  this.getTableInfo()
  },
  mounted () {

  }
}
</script>

<style scoped lang="less">
.content {
  display: flex;
  flex-direction: column;
}
.action-btn {
  display: flex;
  // flex-direction: row-reverse;
  padding: 8px 8px 8px 6px;
}
.table {
  flex: 1;
}
</style>
